import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design-components/base/eco-space';
import css from './index.module.scss';
import EcoCompareSelector from 'eco-design/sections/eco-compare-selector';
import { EcoCompareSelectorType } from 'eco-design/sections/eco-compare-selector/type';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import getSpec from '../../context/getSpec';
import { useProduct, useProductMsg, useProductSpec, useProductState } from '../../ProductProvider';
import { pageParams } from '../../config/page';
import { formatCompareSpec } from 'elem/utils/formatCompareSpec';
import { variantIds, linksMore } from './btns';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';
import useProductInfo from '@/utils/hooks/useProductInfo';
import { useEffect, useMemo, useState } from 'react';
import Dialog from '../C/Dialog';

const JP_KEYS = [
    'Capacity',
    'rapid_outlets',
    'rapid_input',
    'spec_rapid_totaloutput',
    'specs_rapid_singleoutput',
    'specs_app',
    'specs_Screen Display',
    'rapid_dimensions',
    'rapid_weight',
];
const EU_KEYS = [
    'Capacity',
    'rapid_dimensions',
    'rapid_weight',
    'spec_rapid_totaloutput',
    'specs_rapid_singleoutput',
    'rapid_outlets',
    'rapid_input',
    'specs_app',
    'specs_digital_display',
];

const M: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidpro');
    const productMsg = useProductMsg();
    const specs = useProductSpec();
    const variantIdLocale = variantIds[locale] || [];
    const linkLocale = linksMore[locale] || [];

    const [showNotifyMe, setShowNotifyMe] = useState(false);

    const IS_JP = locale === 'jp';
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const buy = useScheduledContent({
        '2025/06/24 15:00:00 GMT+8': t('presale'),
        '2025/07/15 15:00:00 GMT+8': t('buy_now'),
    });

    const checkoutGTM = (productName: string, link: string, k: number) => {
        return {
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${t('buy_now')}_${productName}`,
            __btn_id1: `rapid-pro-M filled-${k}`,
            __btn_id2: link || productName,
            __btn_type: 'href',
        };
    };

    const learmoreGTM = (productName: string, link: string, k: number) => {
        return {
            event: 'uaEvent',
            event_name: 'buy',
            position: `Collections_${t('M_title')}`,
            product_name: productName,
            __btn_id1: `rapid-pro-M text-${k}`,
            __btn_id2: link || productName,
            __btn_type: 'href',
        };
    };
    const [productGroupParams, setProductGroupParams] = useState(null);
    const { generalKeys, generalKeys_eu, generalKeys_jp, generalKeys_ph, generalKeys_nl } = pageParams;
    const curGeneralKeys =
        locale === 'jp' ? generalKeys_jp : locale === 'ph' ? generalKeys_ph : locale === 'nl' ? generalKeys_nl : IS_EU ? generalKeys_eu : generalKeys;
    useEffect(() => {
        if (specs && specs?.length === curGeneralKeys?.length) {
            const catagory = specs?.find((spec) => spec.productCatagory)?.productCatagory;
            const products: any[] = [];
            specs.map((spec) => {
                products.push({
                    skuList: spec?.productDetail?.skuList,
                });
            });
            setProductGroupParams(formatCompareSpec(catagory, products, IS_JP ? JP_KEYS : EU_KEYS) as any);
        }
    }, [specs]);

    const data = [
        {
            productId: (() => {
                const ids = {
                    jp: '14715284160879',
                    eu: '10057124348247',
                    de: '15246671348093',
                    fr: '9916298592603',
                    it: '14929760059768',
                    es: '9916308980059',
                    uk: '9922524315987',
                    us: '15361630044233',
                    ca: '15126335881587',
                    ph: '10322678251830',
                    nl: '9935713599764',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            variantId: (() => {
                const ids = {
                    jp: '51993088622959',
                    eu: '50740155875671',
                    de: '56076475171197',
                    fr: '50627140485467',
                    it: '55140789584248',
                    es: '50627174367579',
                    uk: '51047157825875',
                    us: '54593875509321',
                    ca: '52731600175475',
                    ph: '52941429604662',
                    nl: '51194425377044',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            btns: [
                {
                    href: variantIdLocale[0] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[0]}:1?channel=buy_button` : '',
                    text: buy,
                    // text: IS_JP ? t('buy_now2') : buy,
                    type: 'filled',
                    // disabled: IS_JP,
                    dataLayer: checkoutGTM(
                        t('M_item1_title'),
                        variantIdLocale[0] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[0]}:1?channel=buy_button` : '',
                        1,
                    ),
                },
                {
                    href: linkLocale[0] || '',
                    text: t('learn_more'),
                    type: 'text',
                    icon: true,
                    dataLayer: learmoreGTM(t('M_item1_title'), linkLocale[0] || '', 1),
                },
            ],
        },
        {
            productId: (() => {
                const ids = {
                    jp: '14715334492527',
                    eu: '10057125331287',
                    de: '15246672003453',
                    fr: '9916298821979',
                    it: '14929760158072',
                    es: '9916309569883',
                    uk: '9922529395027',
                    us: '15361638924361',
                    ca: '15126336274803',
                    ph: '10322678317366',
                    nl: '9935713632532',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            variantId: (() => {
                const ids = {
                    jp: '51993093767535',
                    eu: '50740157382999',
                    de: '56076476449149',
                    fr: '50627140813147',
                    it: '55140789846392',
                    es: '50627176595803',
                    uk: '51047163396435',
                    us: '54593876000841',
                    ca: '52731601256819',
                    ph: '52941429702966',
                    nl: '51194425147668',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            btns: [
                {
                    href: variantIdLocale[1] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[1]}:1?channel=buy_button` : '',
                    text: IS_JP ? t('buy_now') : buy,
                    type: 'filled',
                    dataLayer: checkoutGTM(
                        t('M_item2_title'),
                        variantIdLocale[1] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[1]}:1?channel=buy_button` : '',
                        2,
                    ),
                },
                {
                    href: linkLocale[1] || '',
                    text: t('learn_more'),
                    type: 'text',
                    icon: true,
                    dataLayer: learmoreGTM(t('M_item2_title'), linkLocale[1] || '', 2),
                },
            ],
        },
        {
            productId: (() => {
                const ids = {
                    jp: '14715335082351',
                    eu: '10057125888343',
                    de: '15246672593277',
                    fr: '9916299051355',
                    it: '14929760223608',
                    es: '9916309864795',
                    uk: '9922534441299',
                    us: '15361639481417',
                    ca: '15126336504179',
                    ph: '10304284950838',
                    nl: '9935713665300',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            variantId: (() => {
                const ids = {
                    jp: '51993096356207',
                    eu: '50740158071127',
                    de: '56076477432189',
                    fr: '50627141402971',
                    it: '55140789944696',
                    es: '50627177054555',
                    uk: '51047172211027',
                    us: '54627329474633',
                    ca: '52731601584499',
                    ph: '52748208537910',
                    nl: '51194425213204',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            btns: [
                {
                    href: variantIdLocale[2] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[2]}:1?channel=buy_button` : '',
                    text: IS_JP ? t('buy_now') : buy,
                    type: 'filled',
                    dataLayer: checkoutGTM(
                        t('M_item3_title'),
                        variantIdLocale[2] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[2]}:1?channel=buy_button` : '',
                        3,
                    ),
                },
                {
                    href: linkLocale[2] || '',
                    text: t('learn_more'),
                    type: 'text',
                    icon: true,
                    dataLayer: learmoreGTM(t('M_item3_title'), linkLocale[2] || '', 3),
                },
            ],
        },
        {
            productId: (() => {
                const ids = {
                    jp: '14715335573871',
                    eu: '10057126576471',
                    de: '15246672953725',
                    fr: '9916299346267',
                    it: '14929760321912',
                    es: '9916310159707',
                    uk: '',
                    us: '15361639809097',
                    ca: '15126339551603',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            variantId: (() => {
                const ids = {
                    jp: '51993101631855',
                    eu: '50740159218007',
                    de: '56076478447997',
                    fr: '50627143565659',
                    it: '55140790043000',
                    es: '50627177415003',
                    uk: '',
                    us: '54593877606473',
                    ca: '52731615412595',
                };
                return ids[locale as 'jp'] ?? ids['jp'];
            })(),
            btns: [
                {
                    href: variantIdLocale[3] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[3]}:1?channel=buy_button` : '',
                    text: IS_JP ? t('buy_now') : buy,
                    type: 'filled',
                    dataLayer: checkoutGTM(
                        t('M_item4_title'),
                        variantIdLocale[3] ? `https://${locale}.ecoflow.com/cart/${variantIdLocale[3]}:1?channel=buy_button` : '',
                        4,
                    ),
                },
                {
                    href: linkLocale[3] || '',
                    text: t('learn_more'),
                    type: 'text',
                    icon: true,
                    dataLayer: learmoreGTM(t('M_item4_title'), linkLocale[3] || '', 4),
                },
            ],
        },
    ];

    const productInfo: any = useProductInfo(['uk', 'us', 'ca', 'ph', 'nl'].includes(locale) ? data.slice(0, 3) : data, {
        variantImg: 'pc',
        skuTitle: 'title',
    });

    const productName =
        locale === 'nl'
            ? ['EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100', 'product_rapid_pro_charging_dock']
            : locale === 'ph'
            ? ['EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100', 'rapid_pro_012']
            : locale === 'jp'
            ? ['pb501-x', 'EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100', 'rapid_pro_012']
            : ['pb501-x', 'EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100'];

    const props: EcoCompareSelectorType = useMemo(
        () => ({
            title: t('M_title'),
            theme: 'black',
            linkProps: ['ph'].includes(locale)
                ? undefined
                : {
                      className: 'GtmModuleData-btn-href link-desc',
                      href: `https://${locale}.ecoflow.com/collections/power-bank#rapid-pro`,
                      children: t('M_desc') ? (
                          <>
                              <span> {t('M_desc')}</span>
                              <EcoIconArrow />
                          </>
                      ) : null,
                      target: '_blank',
                      dataLayer: {
                          event: 'uaEvent',
                          event_name: 'buy',
                          product_name: 'EcoFlow Rapid Pro',
                          position: `EcoFlow Rapid Pro_${t('M_desc')}`,
                          __btn_id1: `rapid-pro-M .link-desc`,
                          __btn_id2: `https://${locale}.ecoflow.com/collections/power-bank#rapid-pro`,
                          __btn_type: 'href',
                      },
                  },
            items: productInfo.map((i, idx) => ({
                ...i,
                pc: productMsg?.[productName?.[idx]]?.transparentImages || i.pc,
                title: i.title == 'Default Title' ? i.productTitle : i.title,
                items: productInfo?.map((j) => {
                    return {
                        label: j.title == 'Default Title' ? j.productTitle : j.title || productName[idx],
                        value: j.title == 'Default Title' ? j.productTitle : j.title || productName[idx],
                    };
                }),
                subs: productGroupParams && productGroupParams[idx] ? productGroupParams[idx] : [],
            })),
        }),
        [productInfo, locale, productGroupParams, t],
    );

    return (
        <div id="rapid-pro-M" className={`rapid-pro-M ${css.section} GtmModuleData-section`} data-section-id={`rapid-pro-M`} data-section-title={t('M_title')}>
            <EcoSpace />
            {specs && specs?.length === curGeneralKeys?.length ? <EcoCompareSelector {...props} /> : getSpec()}

            {<Dialog open={showNotifyMe} onClose={() => setShowNotifyMe(false)} />}
        </div>
    );
};

export default M;
